import type { StoreId } from "@KassaroAB/shared/types/ids";
import type { RestGetInventoryCosting } from "@KassaroAB/shared/types/costPool";
import type { RestActivateInventoryCosting } from "@KassaroAB/shared/types/inventoryCostingSettings";
import type { RestSerialIssue } from "@KassaroAB/shared/types/stockLedger";
import { api } from "../utils/api";

export const getInventoryCostingApi = async (
  storeId: StoreId,
): Promise<RestGetInventoryCosting> =>
  api.get(`stores/${storeId}/inventoryCosting`);

export const getSerialIssuesApi = async (
  storeId: StoreId,
): Promise<RestSerialIssue[]> =>
  api.get(`stores/${storeId}/inventoryCosting/serialIssues`);

export const activateInventoryCostingApi = async (
  storeId: StoreId,
  data: RestActivateInventoryCosting,
): Promise<RestGetInventoryCosting> =>
  api.post(`stores/${storeId}/inventoryCosting`, data);
